import {Component, Input} from '@angular/core';
import {EventsService} from '../../../../../../../../../../@shared/services/events-service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {EventServiceResponse} from '../../../../../../../../../../@shared/models/response.module';
import {_AQH_EVE_13} from '../../../../../../../../../../@shared/models/input.module';

@Component({
  selector: 'app-edit-event-service',
  standalone: false,
  templateUrl: './edit-event-service.html',
  styleUrl: './edit-event-service.css'
})
export class EditEventService {
  @Input() service: EventServiceResponse

  constructor(private eventService: EventsService,
              private modal: NgbActiveModal) {
  }

  close() {
    this.modal.close();
  }

  saveChanges() {
    let params: _AQH_EVE_13 = {
      event_id: this.service.event_id,
      event_service_id: this.service.event_service_id,
      event_service_name: this.service.event_service_name,
      event_service_description: this.service.event_service_description,
      max_num_registrations: this.service.max_num_registrations,
      price: this.service.price,
      price_currency: this.service.price_currency
    }
    this.eventService.editEventService(params).subscribe((res) => {
      this.modal.close(true);
    })
  }

}
